import ArrowCircularOutlined from './src/arrow-circular-outlined';
export default ArrowCircularOutlined;